import { render, staticRenderFns } from "./PriceListDetailRow.vue?vue&type=template&id=3cb9f132"
import script from "./PriceListDetailRow.vue?vue&type=script&lang=js"
export * from "./PriceListDetailRow.vue?vue&type=script&lang=js"
import style0 from "./PriceListDetailRow.vue?vue&type=style&index=0&id=3cb9f132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports